'use client';

import React, { useContext, useEffect, useMemo } from 'react';
import styles from './customerWelcomePanel.module.scss';
import { useTrack } from '@chewy/use-analytics';
import OHCContext from '@/providers/OHCContext';
import { capitalize, first, words } from 'lodash';

const CustomerWelcomePanel = () => {
  const { customer, isDesktopMode } = useContext(OHCContext);
  const track = useTrack();
  const customerName = useMemo(() => {
    return capitalize(first(words(customer?.fullName || '')));
  }, [customer]);

  useEffect(() => {
    track('Customer Welcome Panel Viewed', {
      id: 'customer-welcome-panel-viewed-id',
      parentId: 'customer-welcome-panel-id',
      level: 'customer-welcome-panel',
      type: 'static',
      position: 1,
      event_name: 'Widget Viewed',
      eventAction: 'impression',
      eventCategory: 'help-center',
      eventLabel: 'help-center-customer-welcome-view',
      name: 'Customer Welcome Panel Viewed'
    });
  }, [track]);

  if (!customerName) {
    return null;
  }
  
  return (
    <div className={styles.customerWelcomePanel}>
      {isDesktopMode ? (
        <div className={styles.customerWelcomePanelDesktop}>{`We're here for you, ${customerName}`}</div>
      ) : (
        <div className={styles.customerWelcomePanelMobile}>
          <div>{`We're here for you,`}</div>
          <div>{`${customerName}`}</div>
        </div>
      )}
    </div>
  );
};

export default CustomerWelcomePanel;
